import { JtiSimpleCodeList } from '.';

export class JtiDocumentAdditionalInfoForCodeList
{
  code: string;
  name: string;
  filter: string;
  required: boolean;
  valueRestriction: string;
  codeLists: JtiSimpleCodeList;
  value: string;
}
